import { actionCreatorFactory } from 'typescript-fsa'
import { Scenario } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerScenarios = actionCreator<Scenario[]>('registerScenarios')
